import {
  Takeover as CXTakeoverModal,
  TakeoverContent as CXTakeoverContent,
  TakeoverFooter as CXTakeoverFooter,
  TakeoverHeader as CXTakeoverHeader
} from '@sanlamcx/react-ui-next-takeover-modal';

export const Takeover = CXTakeoverModal;
export const TakeoverContent = CXTakeoverContent;
export const TakeoverFooter = CXTakeoverFooter;
export const TakeoverHeader = CXTakeoverHeader;
